/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserSettingKey } from './UserSettingKey';
import {
    UserSettingKeyFromJSON,
    UserSettingKeyFromJSONTyped,
    UserSettingKeyToJSON,
    UserSettingKeyToJSONTyped,
} from './UserSettingKey';
import type { JsonNode } from './JsonNode';
import {
    JsonNodeFromJSON,
    JsonNodeFromJSONTyped,
    JsonNodeToJSON,
    JsonNodeToJSONTyped,
} from './JsonNode';

/**
 * 
 * @export
 * @interface UserSettingResponse
 */
export interface UserSettingResponse {
    /**
     * 
     * @type {UserSettingKey}
     * @memberof UserSettingResponse
     */
    key: UserSettingKey;
    /**
     * 
     * @type {JsonNode}
     * @memberof UserSettingResponse
     */
    value: JsonNode | null;
}



/**
 * Check if a given object implements the UserSettingResponse interface.
 */
export function instanceOfUserSettingResponse(value: object): value is UserSettingResponse {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function UserSettingResponseFromJSON(json: any): UserSettingResponse {
    return UserSettingResponseFromJSONTyped(json, false);
}

export function UserSettingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSettingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'key': UserSettingKeyFromJSON(json['key']),
        'value': JsonNodeFromJSON(json['value']),
    };
}

export function UserSettingResponseToJSON(json: any): UserSettingResponse {
    return UserSettingResponseToJSONTyped(json, false);
}

export function UserSettingResponseToJSONTyped(value?: UserSettingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': UserSettingKeyToJSON(value['key']),
        'value': JsonNodeToJSON(value['value']),
    };
}

